<template>
  <section class="py-16 bg-gray-50" id="neuer-standort">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex flex-col gap-8 lg:grid lg:grid-cols-2 lg:items-center">
        <div>
          <span class="inline-flex items-center rounded-full bg-teal-100 px-3 py-1 text-sm font-semibold text-teal-800">
            Neu eröffnet
          </span>
          <h2 class="mt-4 text-3xl md:text-4xl font-extrabold text-gray-800">
            Coffee Specialty Friedrichshain ist geöffnet
          </h2>
          <p class="mt-4 text-lg text-gray-600">
            Unser neuer Standort in Berlin-Friedrichshain ist da. Freu dich auf handverlesene Bohnen,
            feinste Filter- und Espressospezialitäten und eine entspannte Atmosphäre.
          </p>
          <div class="mt-6 text-gray-700">
            <p class="font-semibold">Adresse</p>
            <p>Grünenbergerstr. 58, 10245 Berlin</p>
            <a
              class="mt-2 inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold"
              href="https://www.google.com/maps/search/?api=1&query=Gr%C3%BCnenbergerstr.%2058%2C%2010245%20Berlin"
              target="_blank"
            >
              Auf Google Maps ansehen
            </a>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-3">
          <img
            v-for="(img, idx) in images"
            :key="`neuer-standort-${idx}`"
            :src="img"
            :alt="`Neuer Standort Bild ${idx + 1}`"
            class="h-40 w-full object-cover rounded-lg shadow-md"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NeuerStandortSection',
  data() {
    return {
      images: [
        new URL('@/assets/Neuer Standort/newlocation-web.jpg', import.meta.url).href,
        new URL('@/assets/Neuer Standort/neuerlocation2-web.jpg', import.meta.url).href,
        new URL('@/assets/Neuer Standort/WhatsApp Image 2026-02-07 at 17.23.30-web.jpg', import.meta.url).href,
        new URL('@/assets/Neuer Standort/neuer1-web.jpg', import.meta.url).href,
      ],
    };
  },
};
</script>

<style scoped>
</style>
